import { cn } from "@/utils/cn";

interface SectionHeaderProps {
  title: string;
  gradient: "purple-pink" | "emerald-teal" | "blue-cyan" | "amber-orange";
}

const gradientClasses: Record<SectionHeaderProps["gradient"], string> = {
  "purple-pink": "from-purple-500 to-pink-500",
  "emerald-teal": "from-emerald-500 to-teal-500",
  "blue-cyan": "from-blue-500 to-cyan-500",
  "amber-orange": "from-amber-500 to-orange-500",
};

export function SectionHeader({ title, gradient }: SectionHeaderProps) {
  return (
    <h4 className="text-sm font-semibold mb-3 flex items-center gap-2">
      <div
        className={cn(
          "h-1 w-8 bg-gradient-to-r rounded-full",
          gradientClasses[gradient]
        )}
      />
      {title}
    </h4>
  );
}
